import { Outlet } from 'react-router-dom'
import { useState, useEffect, createContext, useContext } from 'react'
import HeaderDark from './components/Header-Dark'
import LanguageProvider from './contexts/LanguageContext'

// Dark mode context
const DarkModeContext = createContext<{
  isDark: boolean
  toggleDark: () => void
}>({
  isDark: true,
  toggleDark: () => {}
})

export const useDarkMode = () => useContext(DarkModeContext)

export default function App() {
  const [isDark, setIsDark] = useState(() => {
    // Check localStorage or default to dark mode
    const saved = localStorage.getItem('darkMode')
    return saved ? JSON.parse(saved) : true
  })

  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(isDark))
    // Update document class and background for global styling
    if (isDark) {
      document.documentElement.classList.add('dark')
      document.documentElement.style.backgroundColor = '#111827' // gray-900
      document.body.style.backgroundColor = '#111827' // gray-900
    } else {
      document.documentElement.classList.remove('dark')
      document.documentElement.style.backgroundColor = '#ffffff' // white
      document.body.style.backgroundColor = '#ffffff' // white
    }
  }, [isDark])

  const toggleDark = () => setIsDark(!isDark)

  return (
    <LanguageProvider>
      <DarkModeContext.Provider value={{ isDark, toggleDark }}>
        <div className={`min-h-screen w-full max-w-full overflow-x-hidden flex flex-col transition-colors duration-300 ${
          isDark ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
        }`}>
          <HeaderDark />
          <main className="flex-1 w-full max-w-full overflow-x-hidden">
            <Outlet />
          </main>
          <footer className={`border-t py-6 text-center text-sm transition-colors ${
            isDark 
              ? 'border-gray-800 text-gray-400' 
              : 'border-gray-200 text-gray-500'
          }`}>
            © {new Date().getFullYear()} SudanLibrary
          </footer>
        </div>
      </DarkModeContext.Provider>
    </LanguageProvider>
  )
}